import React from 'react';
import TabButton from '../TabButton';

export default ({ tabs }) => tabs.map(
  ({ to, title, id }) => <TabButton id={id} to={to}>{title}</TabButton>,
);
